// extracted by mini-css-extract-plugin
export default {"mediaMediumUp":"(min-width: 48em)","container":"-S+l9Thg-DROGPIV61PW5A==","footer":"kRg-GYC6P5RgzMFGCBvmlQ==","copyright":"yGrRmMX8Dp0U3uue1C340w=="};